<template>
  <RexModalV3
    width="80.625rem"
    :show="showModal"
    @onClose="onModalHide"
    @onSubmit="confirmDelete"
    :submitText="$t('aws.deleteOption')"
    :headerStyle="{ 'border-bottom': 'none' }"
    :title="$t('aws.deleteConfiguration')"
    :footerStyle="{
      display: 'flex',
      width: '100%',
      'flex-direction': 'row-reverse',
      'margin-right': '1rem',
      'border-top': 'rgba(255, 255, 255, 0.3) 1px solid',
      'padding-top': '12px',
    }"
  >
    <template #header>
      <div>
        <h2 class="delete-modal-header">
          {{ $t('aws.deleteConfiguration') }}
        </h2>
      </div>
    </template>
    <template #body>
      <div class="body-content">
        <div class="confirm-box">
          <p class="confirm-msg">
            {{ $t('aws.deleteConfirmationText') }}
            <span class="connection-name-text"> "{{ connectionName }}" </span>
            {{ $t('aws.configurationAsk') }}
          </p>
        </div>
        <div class="warning-box">
          <p class="warning-text">
            {{ $t('aws.deleteConfirmationDescription') }}
          </p>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="footer-buttons-wrapper">
        <RexButton
          id="cancel-configuration-btn"
          @onClick="cancelDelete"
          variant="secondary"
        >
          {{ $t('aws.createNewConfigguration.cancel') }}
        </RexButton>
        <RexButton
          id="delete-configuration-btn"
          @onClick="confirmDelete"
          variant="primary"
        >
          {{ $t('aws.createNewConfigguration.delete') }}
        </RexButton>
      </div>
    </template>
  </RexModalV3>
</template>

<script>
import RexModalV3 from '@/rex-components/RexModalV3.vue';
import RexButton from '@/rex-components/rex-button.vue';
import { mapActions } from 'vuex';
import { REMOVE_CONNECTION } from '@/store/modules/cloud/connections/services.constants';

export default {
  name: 'DeleteModal',
  components: {
    RexModalV3,
    RexButton,
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    connectionName: {
      type: String,
      required: true,
    },
    subscriptionId: {
      type: String,
      required: true,
    },
  },
  methods: {
    ...mapActions('cloudState/connections', [REMOVE_CONNECTION]),
    confirmDelete() {
      this[REMOVE_CONNECTION](this.subscriptionId);
      this.closeModal();
    },
    onModalHide() {
      this.$emit('close');
    },
    cancelDelete() {
      this.closeModal();
    },
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.delete-modal-header {
  @include flex-center-vert;
  font-size: 1rem;
  font-weight: bold;
  color: white;
}

.body-content {
  @include flex-column;
}

.confirm-box {
  @include flex-center-vert;
  padding: 1rem;
  padding-left: 0;
}

.confirm-msg {
  font-size: 1.3rem;
  margin: 0;
}

.warning-box {
  @include flex-center-vert;
  background: #3c3d40;
  padding: 0.8rem;
}

.warning-text {
  margin: 0;
  color: $color-brand-accent;
  font-size: 1.2rem;
}

.footer-buttons-wrapper {
  @include flex-center-justify(space-between);
  gap: 0.625rem;
}

.connection-name-text {
  color: $color-brand-accent;
}
</style>
